export default __webpack_public_path__ + "static/media/bolt.2ea1cbb5.svg";